export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Participantes',
      url: '/participantes',
      icon: 'fa fa-users'
    },
    {
      name: 'Voos',
      url: '/voos',
      icon: 'fa fa-plane'
    },
    {
      name: 'Configurações',
      url: '/configs/edit',
      icon: 'fa fa-cogs'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js